
define('ldsh!modules/form_editor/templates/dropdown', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(labelVisible) { ;
__p += '\n<label class="control-label col-sm-3" for="' +
((__t = ( elementId )) == null ? '' : __t) +
'">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n\n<div class="col-sm-9 js-control">\n  ';
 if (isAMP && url) { ;
__p += '\n  <amp-list layout="fixed-height" height="100" single-item\n    class="amp-dropdown-menu"\n    items="." src="' +
((__t = ( url )) == null ? '' : __t) +
'"\n\n    binding="no">\n    <template type="amp-mustache">\n      <select\n        name="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n        id="' +
((__t = ( elementId )) == null ? '' : __t) +
'">\n        {{#items}}\n        <option value="{{value}}">{{name}}</option>\n        {{/items}}\n      </select>\n    </template>\n  </amp-list>\n  ';
 } else { ;
__p += '\n    <select name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n      id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n      data-url="' +
((__t = ( url )) == null ? '' : __t) +
'"\n      class="form-control js-items ' +
((__t = ( isRequired ? 'form-element-required': '' )) == null ? '' : __t) +
'"\n      ' +
((__t = ( isRequired && isAMP ? 'required' : '')) == null ? '' : __t) +
'>\n    </select>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

